import { SET_OPEN_PAYMENTS } from '@/utils/store/mutationTypes'

export default {
  /**
   * Sets order bundles with open payments.
   *
   * @param state
   * @param payments
   */
  [SET_OPEN_PAYMENTS] (state, payments) {
    state.openPayments = payments
  }
}
